import { ZfDrawer, ZfDrawerContent, ZfStack } from '@zafire/react';
import type { FunctionComponent, ReactNode } from 'react';
import type { ITranslation } from '../../interfaces/generic';
import { AdminContentBox } from './AdminContentBox';
import { AdminItemSearchList } from './AdminItemSearchList';

interface IAdminItem {
    id: number;
    name: ITranslation | string;
}

interface IProps {
    items?: IAdminItem[];
    displayedItem?: IAdminItem;
    itemEditorComponent: ReactNode;
    onItemClick: (itemId: number) => void;
    onCreateClick: () => void;
}

export const AdminContentScreen: FunctionComponent<IProps> = ({ items, displayedItem, itemEditorComponent, onItemClick, onCreateClick }) => {
    if (!items?.length) return;

    return (
        <ZfStack direction="row" style={{ position: 'relative', width: '100vw', height: '100%' }}>
            <ZfDrawer type="persistent" side="left" expanded={true} style={{ minWidth: 'calc(25vw + var(--padding-horizontal-lg))' }}>
                <ZfDrawerContent style={{ minWidth: 'calc(25vw + var(--padding-horizontal-lg))' }}>
                    <AdminItemSearchList
                        onItemClick={onItemClick}
                        highlightItemId={displayedItem && displayedItem.id}
                        items={items}
                        onCreateClick={onCreateClick}
                    />
                </ZfDrawerContent>
            </ZfDrawer>
            {displayedItem ? <AdminContentBox>{itemEditorComponent}</AdminContentBox> : null}
        </ZfStack>
    );
};
